export default "__VITE_ASSET__DJwdi_HK__"